export default {
  loading: false,
  activeStep: 0,
  appConfig: {
    credentials: {
      general: {},
      per_warehouse: {},
    },
    config: {
      general: {},
      per_warehouse: {},
    },
    sysnode: {
      general: {},
      per_warehouse: {},
    },
  },
  searchedAppList: [],
  appDetails: {},
  contact: {},
  warehouses: null,
  appNameFilterFieldValue: '',
  includedWarehouses: [],
  selfServiceList: [],
  appSelfServiceWithoutFilter: [],
  installationId: null,
  logisticProviderList: [],
  lpRequestData: {
    company_name: null,
    client_id: null,
    client_name: null,
    client_email: null,
    client_phone_number: null,
    lp_contact_name: null,
    lp_contact_email: null,
    lp_contact_phone_number: null,
    logistic_provider: null,
    client_modules: null,
    additional_information: null,
    has_contract: null,
    contract_number: null,
    include_quote_table: null,
    client_consent: null,
    warehouses: [],
    quote_table: {},
    clientInfo: {},
  },
  modal: false,
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-integrations/features/integrations-app-self-service/store/states.js